/**
 * Policy term status badge — dot + label, coloured per the Policies design
 * note (OR-1537), and reused by the policy record page (OR-1639), whose
 * design says "same colors and status from the policies page".
 */
import { BadgeWithDot } from "@tricura/atlas-ui";
import type { PolicyTermStatus } from "../../api";
import { STATUS_LABELS } from "./filters";

type BadgeColor = "success" | "blue" | "warning" | "gray" | "error";

const STATUS_COLOR: Record<PolicyTermStatus, BadgeColor> = {
    in_force: "success",
    bound: "blue",
    pending_inception: "gray",
    run_off: "gray",
    expired: "gray",
    pending_cancellation: "warning",
    cancelled: "error",
    void: "error",
};

export function PolicyStatusBadge({ status }: { status: PolicyTermStatus }) {
    return (
        <BadgeWithDot color={STATUS_COLOR[status] ?? "gray"} type="modern" size="sm">
            {STATUS_LABELS[status] ?? status}
        </BadgeWithDot>
    );
}
